import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";

// Client-side fallback for any route React Router doesn't match. The real
// HTTP status (404/410) for crawlers is handled server-side by the
// seoRender Cloud Function (see functions/seoRender.js) — this is only
// about not leaving a real, JS-enabled visitor staring at a blank page.
const NotFound = () => {
  useEffect(() => {
    document.title = "Siden ble ikke funnet | Mapli";
  }, []);

  return (
    <div className='homePageContainer'>
      <Header />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
          minHeight: "60vh",
          padding: 40,
          textAlign: "center",
        }}>
        <h1 className='editPageLabel'>Siden finnes ikke</h1>
        <p>Vi fant ikke siden du lette etter.</p>
        <Link to='/' className='editPageLabel' style={{ textDecoration: "underline" }}>
          Til forsiden
        </Link>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
